/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

/**
 * Resolves per-account branding (logo, favicon, accent color, brand name)
 * from the active account's custom_attributes, falling back to the global
 * Solvetia config when the account has no branding set.
 */
export function useAccountBranding() {
  const { currentAccount } = useAccount();
  const globalConfig = useMapGetter('globalConfig/get');

  const attrs = computed(() => currentAccount.value?.custom_attributes || {});

  const brandName = computed(
    () => attrs.value.brand_name || globalConfig.value?.installationName || ''
  );
  const logo = computed(
    () =>
      attrs.value.brand_logo_url ||
      attrs.value.logo_url ||
      globalConfig.value?.logoThumbnail ||
      ''
  );
  const logoDark = computed(
    () => attrs.value.brand_logo_dark_url || attrs.value.logo_dark_url || null
  );
  const brandColor = computed(
    () => attrs.value.brand_color || globalConfig.value?.brandColor || null
  );
  const favicon = computed(
    () => attrs.value.brand_favicon_url || attrs.value.favicon_url || null
  );

  return { brandName, brandColor, logo, logoDark, favicon };
}
